<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_vii"></a><strong>SWIMMING IN THE VOLCANO</strong></p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?a2fc4eea